import * as swcHelpers from '@swc/helpers';
import 'react';
import '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../types/product.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/inventory';
import '../../../../slots/context.js';
import '@grandvisionhq/svc-tealium/components';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import { isWithoutRx } from '../../components/RxableSelect/is-rx-radio-selection.js';
import '@grandvisionhq/lib-utils-html';
import { POWER_ZERO } from '../constants.js';
import { getMaxSelectableQuantity } from '../utils/get-max-selectable-quantity.js';

var getActions = (dispatch)=>{
    const updatePurchaseType = (purchaseType)=>{
        dispatch({
            type: 'setPurchaseType',
            payload: {
                purchaseType
            }
        });
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'resetErrors'
        });
    };
    const updatePrescriptionAttribute = (eyeSide, attribute, value)=>{
        const payload = {
            eyeSide,
            attribute,
            value
        };
        dispatch({
            type: 'setPrescriptionAttribute',
            payload
        });
        dispatch({
            type: 'updateStockStatus',
            payload: {
                eyeSide,
                stockIndicatorStatus: undefined
            }
        });
        dispatch({
            type: 'resetFetchedSku',
            payload: {
                eyeSide
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateSelectedQuantity = (eyeSide, quantity)=>{
        dispatch({
            type: 'setSelectedQuantity',
            payload: {
                eyeSide,
                quantity
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateTotalQuantity = (totalQuantity)=>{
        dispatch({
            type: 'setTotalQuantity',
            payload: {
                totalQuantity
            }
        });
    };
    const resetTotalQuantity = ()=>{
        dispatch({
            type: 'resetTotalQuantity'
        });
    };
    const updateColumnCheckbox = (eyeSide, isEnabled)=>{
        dispatch({
            type: 'setColumnCheckbox',
            payload: {
                eyeSide,
                isEnabled
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateDeliveryInterval = (deliveryInterval)=>{
        dispatch({
            type: 'setDeliveryInterval',
            payload: {
                deliveryInterval
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateRxToggleSelection = (rxToggle)=>{
        dispatch({
            type: 'setRxToggleSelection',
            payload: {
                rxToggle
            }
        });
        if (isWithoutRx(rxToggle)) {
            dispatch({
                type: 'setPrescriptionAttribute',
                payload: {
                    eyeSide: 'both',
                    attribute: 'power',
                    value: POWER_ZERO
                }
            });
        }
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateQueryResult = (_param)=>{
        var { eyeSide , maxOrderableQuantity  } = _param, result = swcHelpers.objectWithoutProperties(_param, [
            "eyeSide",
            "maxOrderableQuantity"
        ]);
        dispatch({
            type: 'setQueryLoading',
            payload: {
                eyeSide,
                loading: false
            }
        });
        if ('error' in result) {
            dispatch({
                type: 'updateQueryError',
                payload: {
                    eyeSide,
                    error: result.error
                }
            });
            return;
        }
        const { sku , allowBackOrder , availableQuantity , stockIndicatorStatus  } = result.prescriptionCLProduct;
        const maxSelectableQuantity = getMaxSelectableQuantity({
            allowBackOrder,
            availableQuantity,
            maxOrderableQuantity
        });
        dispatch({
            type: 'updateFetchedSku',
            payload: {
                eyeSide,
                sku
            }
        });
        dispatch({
            type: 'updateStockStatus',
            payload: {
                eyeSide,
                stockIndicatorStatus
            }
        });
        dispatch({
            type: 'updateQueryError',
            payload: {
                eyeSide,
                error: undefined
            }
        });
        dispatch({
            type: 'updateMaxSelectableQuantity',
            payload: {
                eyeSide,
                maxSelectableQuantity
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const triggerValidationErrors = ()=>{
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'triggerErrors'
        });
    };
    const setQueryLoading = ({ eyeSide , loading  })=>{
        dispatch({
            type: 'resetFetchedSku',
            payload: {
                eyeSide
            }
        });
        dispatch({
            type: 'setQueryLoading',
            payload: {
                eyeSide,
                loading
            }
        });
    };
    return {
        setQueryLoading,
        triggerValidationErrors,
        updateColumnCheckbox,
        updateDeliveryInterval,
        updatePrescriptionAttribute,
        updatePurchaseType,
        updateQueryResult,
        updateRxToggleSelection,
        updateSelectedQuantity,
        updateTotalQuantity,
        resetTotalQuantity
    };
};

export { getActions };
//# sourceMappingURL=actions.js.map
